// Clean App.js - Modern Architecture for MealFlow Kiosk System
// Eliminates complex hook patching with clean, modular approach

import "phoenix_html";
import { Socket } from "phoenix";
import { LiveSocket } from "phoenix_live_view";
import Alpine from 'alpinejs';
import { initializeBrowserRuntime } from './runtime/browser_runtime.js';
import { initializeAlpineRuntime, startAlpineRuntime } from './runtime/alpine_runtime.js';
import { buildHooksRegistry } from './hooks/index.js';
import { DeviceConnection, deviceLiveSocketOptions } from './runtime/device_connection.js';

initializeAlpineRuntime(Alpine);
const Hooks = buildHooksRegistry();
window.Hooks = Hooks;

let liveSocket = null;

const bootLiveView = () => {
  if (window.__mealflowLiveSocketStarted) return;
  window.__mealflowLiveSocketStarted = true;

  startAlpineRuntime();

  const csrfEl = document.querySelector("meta[name='csrf-token']");
  const csrfToken = csrfEl && csrfEl.getAttribute("content");

  try {
    if (csrfToken) {
      liveSocket = new LiveSocket("/live", Socket, {
        ...(document.querySelector('[data-device-kind]') ? deviceLiveSocketOptions : {}),
        params: { _csrf_token: csrfToken },
        hooks: Hooks,
        dom: {
          onBeforeElUpdated(from, to) {
            if (from._x_dataStack) {
              window.Alpine.clone(from, to);
            }
          }
        }
      });
    }
  } catch (_) { }

  window.liveSocket = liveSocket;

  if (liveSocket && document.querySelector('[data-device-kind]')) {
    window.deviceConnection = new DeviceConnection(liveSocket);
  }

  if (liveSocket) {
    liveSocket.connect();
  }

  initializeBrowserRuntime(liveSocket);
};

if (document.readyState === "complete") {
  bootLiveView();
} else {
  window.addEventListener("DOMContentLoaded", bootLiveView, { once: true });
}

export { liveSocket };
